import moment from 'moment-timezone';
moment.tz.setDefault('Europe/Moscow');

export const formatTimezoneLabel = (timezoneName) => {
    const timezone = timezoneName || 'Europe/Moscow';
    const offsetMinutes = moment().tz(timezone).utcOffset();
    const sign = offsetMinutes >= 0 ? '+' : '-';
    const absOffsetMinutes = Math.abs(offsetMinutes);
    const hours = Math.floor(absOffsetMinutes / 60);
    const minutes = absOffsetMinutes % 60;
    const gmtOffset = minutes === 0 ? `${sign}${hours}` : `${sign}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
    return `${timezone} GMT${gmtOffset}`;
};

export const getTimezoneOptions = () => (
    moment.tz.names().map((name) => ({
        key: name,
        value: formatTimezoneLabel(name),
    }))
);

class DateTimeComponent {
    static fromIso(isoString) {
        return new DateTimeComponent(moment(isoString));
    }

    static fromDateTimeStrings(dateString, timeString, timezoneName) {
        // Parse user-entered date/time as local wall clock in selected timezone.
        const dateTimeStr = `${dateString || moment().format('YYYY-MM-DD')} ${timeString || '00:00'}`;
        const timezone = timezoneName || 'Europe/Moscow';
        return new DateTimeComponent(
            moment.tz(dateTimeStr, 'YYYY-MM-DD HH:mm', timezone),
        );
    }

    constructor(dateTime) {
        this.dateTime = dateTime;
    }

    toDateString() {
        return this.dateTime.format('YYYY-MM-DD');
    }

    toTimeString() {
        return this.dateTime.format('HH:mm');
    }

    toString() {
        return this.dateTime.format(`${this.toDateString()} ${this.toTimeString()}`);
    }

    toDate() {
        return this.dateTime.toDate();
    }

    toISO() {
        return this.dateTime.format();
    }

    formatMedium() {
        return this.dateTime.format('LLL');
    }
}

export default DateTimeComponent;



// WEBPACK FOOTER //
// ./src/incab/common/dateTime/index.js